var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemGrid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9.53 12.889c.873 0 1.581.708 1.581 1.58v3.95A1.58 1.58 0 0 1 9.531 20H5.58A1.58 1.58 0 0 1 4 18.42v-3.95c0-.873.708-1.581 1.58-1.581Zm8.89 0c.872 0 1.58.708 1.58 1.58v3.95A1.58 1.58 0 0 1 18.42 20h-3.95a1.58 1.58 0 0 1-1.581-1.58v-3.95c0-.873.708-1.581 1.58-1.581Zm-8.89 1.58H5.58v3.95h3.95zm8.89 0h-3.95v3.95h3.95zM9.53 4c.873 0 1.581.708 1.581 1.58v3.95a1.58 1.58 0 0 1-1.58 1.581H5.58A1.58 1.58 0 0 1 4 9.531V5.58C4 4.707 4.708 4 5.58 4Zm8.89 0c.872 0 1.58.708 1.58 1.58v3.95a1.58 1.58 0 0 1-1.58 1.581h-3.95a1.58 1.58 0 0 1-1.581-1.58V5.58c0-.873.708-1.581 1.58-1.581ZM9.53 5.58H5.58v3.95h3.95zm8.89 0h-3.95v3.95h3.95z"
})));
export default SvgGemGrid;